import { View } from 'react-native';

import { Skeleton, SkeletonTextBlock, createMqStyles, tokens } from '@fhs/ui';

export default function DonationContainerSkeleton() {
  const mqStyles = useMqStyles();

  return (
    <View style={[mqStyles.skeletonContainer]}>
      <View style={{ flexDirection: 'row', alignItems: 'center', gap: 12, marginBottom: 8 }}>
        <Skeleton style={mqStyles.imageContainer} />
        <SkeletonTextBlock lines={1} style={mqStyles.textContainer} />
      </View>
      <View style={mqStyles.buttonGroup}>
        <Skeleton style={mqStyles.skeletonButton} />
        <Skeleton style={mqStyles.skeletonButton} />
        <Skeleton style={mqStyles.skeletonButton} />
        <Skeleton style={mqStyles.skeletonButton} />
        <Skeleton style={mqStyles.skeletonButton} />
      </View>
    </View>
  );
}

const useMqStyles = createMqStyles({
  skeletonContainer: {
    $base: {
      paddingVertical: 13,
      paddingHorizontal: 8,
      marginBottom: 24,
      width: '100%',
      height: 186,
      borderColor: tokens.colors.$black10,
      borderWidth: 1,
      borderRadius: 8,
    },
  },
  imageContainer: {
    $base: {
      height: 60,
      width: 60,
      borderRadius: 50,
    },
  },
  textContainer: {
    $base: {
      width: '85%',
      minHeight: 65,
      padding: 20,
    },
  },
  buttonGroup: {
    $base: {
      flex: 1,
      flexDirection: 'row',
      paddingVertical: 13,
      gap: 8,
      justifyContent: 'center',
    },
  },
  skeletonButton: {
    $base: {
      flex: 1,
      minWidth: 20,
      maxWidth: 213,
      height: 48,
      borderRadius: 100,
    },
  },
});
